import React from 'react'
import { Alert, Progress, } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * Gives user information on the progress of the
 * csv data processing.
 */
function ProgressDiv ({
  processedStudents, 
  status,
  totalStudents, 
}) {
  const display_progress = totalStudents > 0
  let progressValue = 0
  if (display_progress) {
    progressValue = Math.round(processedStudents / totalStudents * 100)
  }
  return (
    <div>
      <div className='mt-1'>{status && <Alert>{status}</Alert>}</div>
      <div className='text-center'>
        {display_progress && `${processedStudents} out of ${totalStudents} complete.`}
      </div>
      {display_progress &&
        <Progress 
          className='mt-1 mb-1' 
          value={progressValue + ''}
        />
      }
    </div>
  )
}

const { number, string } = PropTypes
ProgressDiv.propTypes = {
  processedStudents: number.isRequired,
  status: string,
  totalStudents: number.isRequired,
}

export default ProgressDiv


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/ProgressDiv.js